export function validarDatosIMC(altura, peso) {
  // Convertir a números (por si vienen de inputs tipo string)
  const alturaNum = Number(altura);
  const pesoNum = Number(peso);

  // Validar que ambos sean números
  if (isNaN(alturaNum) || isNaN(pesoNum)) {
    return { valido: false, mensaje: "Altura y peso deben ser números." };
  }

  // Validar altura (límites: 0.50m a 2.50m)
  if (alturaNum < 0.5) {
    return { valido: false, mensaje: "La altura no puede ser menor a 0.50 m." };
  }
  if (alturaNum > 2.5) {
    return { valido: false, mensaje: "La altura no puede ser mayor a 2.50 m." };
  }

  // Validar peso (límites: 10kg a 300kg)
  if (pesoNum < 10) {
    return { valido: false, mensaje: "El peso no puede ser menor a 10 kg." };
  }
  if (pesoNum > 300) {
    return { valido: false, mensaje: "El peso no puede ser mayor a 300 kg." };
  }

  // Si todo es válido
  return { valido: true, mensaje: "Datos válidos." };
}

export function validarPace(pace) {
  // Verificar que el formato sea MM:SS con regex
  const formatoValido = /^[0-9]{1,2}:[0-5][0-9]$/.test(pace);

  if (!formatoValido) {
    return {
      valido: false,
      mensaje:
        "Formato de Pace inválido. Debe ser MM:SS (ej: 05:30). Los segundos deben ser entre 00 y 59.",
    };
  }

  // Separar minutos y segundos
  const [minutosStr, segundosStr] = pace.split(":");
  const minutos = parseInt(minutosStr, 10);
  const segundos = parseInt(segundosStr, 10);

  // Validar minutos (ej: no "99:30")
  if (minutos < 0 || minutos > 59) {
    return {
      valido: false,
      mensaje: "Los minutos deben estar entre 00 y 59.",
    };
  }

  // Si todo es correcto
  return {
    valido: true,
    mensaje: "Pace válido.",
  };
}
